<mat-dialog-content>
  <div class="loading" *ngIf="!loaded">
    <mat-spinner class="spinner" diameter="30"></mat-spinner>
  </div>

  <div *ngIf="loaded">
    <!-- this solves the problem of reading all popup content after initialization by NVDA tool -->
    <div tabindex="0" aria-label="dialog" style="position: absolute"></div>

    <div class="header">
      <h1>{{ eligibility_popup_title }}</h1>
      <mat-icon
        class="close-cross"
        [class.prelogin-close-icon]="preloginHomepage"
        role="button"
        tabindex="0"
        aria-label="close"
        aria-hidden="false"
        (accessibleClick)="closePopUp()"
      >
        close
      </mat-icon>
    </div>
    <div tabindex="0" class="modal-body">{{ eligibility_popup_body }}</div>
    <form [formGroup]="eligibilityForm">
      <div *ngIf="showSelectProduct" class="select-product">
        <mat-form-field [ngClass]="{ selected: eligibilityForm.value.product_id }" appearance="outline">
          <mat-select
            required
            panelClass="my-select-panel-class"
            [placeholder]="'EligibilityDropdown:SelectProduct' | translate"
            formControlName="product_id"
            aria-label="Select a product"
          >
            <mat-option [value]="product.id" *ngFor="let product of products | async">
              {{ product.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="digits">
        <mat-form-field class="col-sm-12 first-n-digits" appearance="outline">
          <span matPrefix>{{ firstNDigitsPlaceholderTAG | translate }} &nbsp;</span>
          <span class="placeholder" [hidden]="firstNDigitsPlaceholderHidden">{{ firstNDigitsPlaceholderString }}</span>
          <input
            type="tel"
            matInput
            attr.aria-label="{{ 'First ' + firstNDigitsEligibilityPanLength + ' digits' }}"
            (focus)="firstNDigitsPlaceholderHidden = true"
            (blur)="onBlur()"
            formControlName="first_n_digits"
            maxLength="{{ firstNDigitsEligibilityPanLength }}"
          />
        </mat-form-field>
        <mat-form-field class="col-sm-12 last-two-digits" appearance="outline">
          <span matPrefix>{{ lastNDigitsPlaceholderTAG | translate }} &nbsp;</span>
          <span class="placeholder" [hidden]="lastNDigitsPlaceholderHidden">{{ lastNDigitsPlaceholderString }}</span>
          <input
            type="tel"
            matInput
            attr.aria-label="{{ 'Last ' + lastNDigitsEligibilityPanLength + ' digits' }}"
            (focus)="lastNDigitsPlaceholderHidden = true"
            (blur)="onBlur()"
            formControlName="last_n_digits"
            maxLength="{{ lastNDigitsEligibilityPanLength }}"
          />
        </mat-form-field>
      </div>
      <div
        *ngIf="hasErrors()"
        tabindex="0"
        class="error-msg"
        [translate]="'EligibilityCheck:MustBeValid'"
        attr.aria-label="{{
          'First' +
            firstNDigitsEligibilityPanLength +
            'and last' +
            lastNDigitsEligibilityPanLength +
            'digits are required'
        }}"
      >
        First {{ firstNDigitsEligibilityPanLength }} and last {{ lastNDigitsEligibilityPanLength }} digits are required
      </div>
    </form>

    <div class="captcha-banner">
      <div
        tabindex="0"
        *ngFor="let child of reCaptchaCustomisableSection?.content?.children"
        class="recaptcha"
        [innerHTML]="child?.body"
      ></div>
    </div>

    <div class="re-captcha-box">
      <re-captcha
        *ngIf="captchaLanguage && enableRecaptcha"
        site_key="6LeS4KsUAAAAAH5apd5lwvbc8WLWNgi16d2CprVP"
        language="{{ captchaLanguage }}"
        [tabindex]="-1"
        size="invisible"
        [global]="true"
        (captchaResponse)="checkEligibility($event)"
      >
      </re-captcha>
    </div>

    <div class="button-container">
      <button
        class="button-container__confirm"
        [class.prelogin-confirm-button]="preloginHomepage"
        aria-label="confirm"
        mat-raised-button
        (click)="enableRecaptcha ? confirm() : checkEligibility('')"
        (keyup.enter)="enableRecaptcha ? confirm() : checkEligibility('')"
        (keyup.space)="enableRecaptcha ? confirm() : checkEligibility('')"
        [disabled]="eligibilityForm.invalid"
      >
        {{ 'ProgressBarComponent:TitleConfirm' | translate }}
      </button>
    </div>
  </div>
</mat-dialog-content>
